import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import NewsNavigation from './NewsNavigation';
import VerticalFooter from './VerticalFooter';
import WrapperTemplate from 'templates/SidebarTemplate/WrapperTemplate';
import InstructionNavigation from './InstructionNavigation';
import ProductNavigation from './ProductNavigation';
import PriceListNavigation from './PriceListNavigation';
import Button from 'ui/Button';
import Logo from 'components/Logo';
import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const Sidebar = ({ active, navigation }) => {
   const l = useLocation();
   return (
      <Wrapper active={active}>
         <StyledWrapperTemplate>
            <StyledLogo />
            {navigation === 'secondary' && (
               <StyledLink to="/katalog/kategorie">
                  <StyledButton reverse>
                     <FormattedMessage id="BackToCategory" />
                  </StyledButton>
               </StyledLink>
            )}
            <NavigationWrapper>
               {l.pathname.includes('instrukcje') && <InstructionNavigation />}
               {navigation === 'product' && <ProductNavigation />}
               {navigation === 'priceList' && <PriceListNavigation />}
               {l.pathname.includes('news') && <NewsNavigation />}
               <VerticalFooter />
            </NavigationWrapper>
         </StyledWrapperTemplate>
      </Wrapper>
   );
};

const StyledLink = styled(Link)`
   text-decoration: none;

   &:hover {
      text-decoration: none;
   }
`;

const StyledWrapperTemplate = styled(WrapperTemplate)`
   padding: 0;

   ${devices.tabletXL} {
      display: flex;
      flex-direction: column;
      align-items: space-between;
      min-height: calc(100vh - 46px);
   }
`;

const StyledLogo = styled(Logo)`
   display: none;
   visibility: hidden;

   ${devices.tabletXL} {
      display: block;
      visibility: visible;
   }
`;

const Wrapper = styled.div`
   position: fixed;
   z-index: 1000;
   top: 0;
   left: 0;
   width: 100%;
   height: 100vh;
   padding: 80px 20px 0;
   background-color: ${colors.neutral70};
   transform: translateX(${({ active }) => (active ? '0' : '-100%')});

   ${devices.mobile} {
      width: 50%;
   }

   ${devices.tabletL} {
      width: 40%;
      padding: 80px 60px 0;
   }

   ${devices.tabletXL} {
      position: static;
      padding: 25px 20px 0 100px;
      transform: translateX(0);
      height: auto;
   }

   ${devices.desktop} {
      width: 38%;
      padding: 46px 40px 0 100px;
   }

   ${devices.desktopHD} {
      width: 30%;
      padding-right: 60px;
   }

   ${devices.desktopFHD} {
      width: 36%;
      padding-right: 74px;
   }
`;

const StyledButton = styled(Button)`
   align-self: flex-start;

   ${devices.tabletXL} {
      margin-top: 30px;
   }

   ${devices.desktop} {
      margin-top: 50px;
   }
`;

const NavigationWrapper = styled.div`
   flex: 1;
   height: calc(100vh - 150px);
   margin-top: 20px;
   overflow-y: scroll;

   ::-webkit-scrollbar {
      width: 6px;
   }

   ::-webkit-scrollbar-track {
      background: ${colors.neutral60};
      border-radius: 3px;
   }

   ::-webkit-scrollbar-thumb {
      background: ${colors.neutral50};
      border-radius: 3px;
   }

   ::-webkit-scrollbar-thumb:hover {
      background: ${colors.neutral40};
   }

   ${devices.tabletXL} {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: visible;
      height: 100%;
      padding-bottom: 40px;
   }

   ${devices.desktop} {
      margin-top: 26px;
   }
`;

Sidebar.propTypes = {
   active: PropTypes.bool.isRequired,
   navigation: PropTypes.string.isRequired
};

export default Sidebar;
